import { render } from "./DateSelectorV2.vue?vue&type=template&id=10788723&scoped=true"
import script from "./DateSelectorV2.vue?vue&type=script&lang=ts"
export * from "./DateSelectorV2.vue?vue&type=script&lang=ts"

import "./DateSelectorV2.vue?vue&type=style&index=0&id=10788723&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-10788723"

export default script
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QIcon,QBtn});
